/**
 * MDU Platinum Jubilee (1951 - 2026) Archival Seed Dataset
 * Jesuit Madurai Province Archives (JEMPARC)
 */

export const INITIAL_EVENTS = [
  {
    id: "evt-jubilee-2026",
    title: "Platinum Jubilee Grand Celebration (2026)",
    year: "2026",
    date: "2026-01-15",
    category: "Jubilee Celebrations",
    description: "The inauguration and grand solemn Eucharistic celebration marking the 75th year (Platinum Jubilee) of the Jesuit Madurai Province (1951-2026).",
    banner: "https://images.unsplash.com/photo-1548625361-195982885942?auto=format&fit=crop&w=1200&q=80",
    location: "Sacred Heart College & St. Mary's Cathedral, Madurai",
    featured: true,
  },
  {
    id: "evt-inauguration-2026",
    title: "Platinum Jubilee Inaugural Convocation",
    year: "2026",
    date: "2026-02-04",
    category: "Inauguration",
    description: "Inaugural assembly welcoming international delegates, ecclesiastical dignitaries, and province leaders to commence the jubilee year festivities.",
    banner: "https://images.unsplash.com/photo-1511578314322-379afb476865?auto=format&fit=crop&w=1200&q=80",
    location: "Loyola Hall, Shembaganur",
    featured: true,
  },
  {
    id: "evt-cultural-2026",
    title: "Jesuit Heritage & Cultural Festival 2026",
    year: "2026",
    date: "2026-03-12",
    category: "Cultural Programmes",
    description: "Traditional music, choral cantatas, drama performances, and folklore presentations recounting the historical journey of the Madurai Mission.",
    banner: "https://images.unsplash.com/photo-1465847899084-d164df4dedc6?auto=format&fit=crop&w=1200&q=80",
    location: "St. Joseph's Auditorium, Tiruchirappalli",
    featured: false,
  },
  {
    id: "evt-academic-2026",
    title: "International Symposium on Archival Heritage & Mission",
    year: "2026",
    date: "2026-04-18",
    category: "Academic Events",
    description: "Scholarly symposium featuring historians, research archivists, and theological scholars on the impact of Jesuit contributions in Tamil Nadu and South Asia.",
    banner: "https://images.unsplash.com/photo-1524178232363-1fb2b075b655?auto=format&fit=crop&w=1200&q=80",
    location: "Arrupe Centre for Higher Research, Madurai",
    featured: false,
  },
  {
    id: "evt-alumni-2026",
    title: "All-India Jesuit Alumni Platinum Jubilee Assembly",
    year: "2026",
    date: "2026-05-22",
    category: "Alumni Events",
    description: "Grand gathering of alumni across decades from Loyola, St. Joseph's, St. Xavier's, and affiliated Madurai Province institutions.",
    banner: "https://images.unsplash.com/photo-1523580494863-6f3031224c94?auto=format&fit=crop&w=1200&q=80",
    location: "Loyola College Grounds, Chennai",
    featured: false,
  },
  {
    id: "evt-golden-2001",
    title: "Golden Jubilee Celebrations (2001)",
    year: "2001",
    date: "2001-08-15",
    category: "Jubilee Celebrations",
    description: "Historic 50th year milestone commemorations of the province, marked by the digitization initiative commencement at JEMPARC.",
    banner: "https://images.unsplash.com/photo-1519741497674-611481863552?auto=format&fit=crop&w=1200&q=80",
    location: "Shembaganur, Kodaikanal",
    featured: true,
  },
  {
    id: "evt-silver-1976",
    title: "Silver Jubilee Memorial & Archival Assembly (1976)",
    year: "1976",
    date: "1976-11-20",
    category: "Jubilee Celebrations",
    description: "25th anniversary assembly of the independent Madurai Jesuit Province with Fr. John Pujo SJ presiding over historical exhibitions.",
    banner: "https://images.unsplash.com/photo-1447069387593-a5de0862481e?auto=format&fit=crop&w=1200&q=80",
    location: "St. Mary's, Madurai",
    featured: false,
  },
  {
    id: "evt-foundation-1952",
    title: "Promulgation & Foundation of the Madurai Province (1952)",
    year: "1952",
    date: "1952-03-12",
    category: "Church Events",
    description: "Official canonical decree and solemn celebration establishing the autonomous Jesuit Madurai Province in post-independence India.",
    banner: "https://images.unsplash.com/photo-1461360370896-922624d12aa1?auto=format&fit=crop&w=1200&q=80",
    location: "Shembaganur, Kodaikanal",
    featured: true,
  }
];

export const INITIAL_CATEGORIES = [
  { id: "cat-jubilee", name: "Jubilee Celebrations", description: "Milestones, jubilees, inaugurations, and commemorative convocations.", icon: "Award" },
  { id: "cat-history", name: "Historical Documents & Manuscripts", description: "Original palm leaves, decrees, Latin letters, and archival manuscripts.", icon: "BookOpen" },
  { id: "cat-spiritual", name: "Spiritual & Liturgical", description: "Sermons, retreat reflections, hymnals, liturgical recordings, and homilies.", icon: "Sparkles" },
  { id: "cat-mission", name: "Mission & Institutions", description: "Records of colleges, schools, rural missions, social action centres, and parishes.", icon: "Building2" },
  { id: "cat-people", name: "Provincials, Archivists & Personalities", description: "Portraits, biographical memoirs, journals, and speeches of prominent Jesuits.", icon: "Users" },
  { id: "cat-academic", name: "Academic & Research Publications", description: "Theses, historical journals, monograph studies, and mission periodicals.", icon: "GraduationCap" },
  { id: "cat-cultural", name: "Cultural & Arts", description: "Dramas, traditional music, choral cantatas, and Jubilee festivities.", icon: "Palette" },
  { id: "cat-interviews", name: "Oral Histories & Audio Speeches", description: "Recorded voice interviews, testimonies, speeches, and conference addresses.", icon: "Mic" },
  { id: "cat-publications", name: "Souvenirs & Province Bulletins", description: "Centenary souvenirs, province newsletters, and published records.", icon: "FileText" }
];

export const TIMELINE_DECADES = [
  { decade: "1950s", range: "1950 - 1959", summary: "Establishment of the independent Madurai Province (1952) and early growth in post-independence Tamil Nadu." },
  { decade: "1960s", range: "1960 - 1969", summary: "Vatican II transitions, expansion of educational institutions, and archival consolidation under Fr. Augustine Sauliere SJ." },
  { decade: "1970s", range: "1970 - 1979", summary: "Celebration of the Silver Jubilee (1976), rural outreach foundations, and cultural indigenization movements." },
  { decade: "1980s", range: "1980 - 1989", summary: "Social justice initiatives, expansion into Dalit empowerment, and scholarly preservation of Tamil classical heritage." },
  { decade: "1990s", range: "1990 - 1999", summary: "Technological modernization, inter-religious dialogue colloquiums, and province centenary retrospectives." },
  { decade: "2000s", range: "2000 - 2009", summary: "Golden Jubilee milestone (2001) and the systematic digitization of thousands of archival manuscripts." },
  { decade: "2010s", range: "2010 - 2019", summary: "Eco-justice missions, university upgrades, and expansion of global scholarly research at JEMPARC." },
  { decade: "2020s", range: "2020 - 2025", summary: "Digital heritage transformations, modern preservation labs, and Platinum Jubilee preparation." },
  { decade: "2026", range: "2026 (Jubilee Year)", summary: "The historic 75th Platinum Jubilee celebration of the Jesuit Madurai Province." }
];

export const INITIAL_MEDIA_ITEMS = [
  // =================== VIDEOS ===================
  {
    id: "vid-001",
    title: "Platinum Jubilee Commemorative Documentary: 75 Years in Service of Truth",
    description: "A comprehensive archival documentary tracing the journey of the Madurai Jesuit Province from its canonical foundation in 1952 to the grand Platinum Jubilee in 2026.",
    mediaType: "video",
    fileName: "platinum_jubilee_documentary_2026.mp4",
    fileUrl: "https://commondatastorage.googleapis.com/gtv-videos-bucket/sample/BigBuckBunny.mp4",
    thumbnailUrl: "https://images.unsplash.com/photo-1548625361-195982885942?auto=format&fit=crop&w=800&q=80",
    eventId: "evt-jubilee-2026",
    eventName: "Platinum Jubilee Grand Celebration (2026)",
    categoryId: "cat-jubilee",
    categoryName: "Jubilee Celebrations",
    year: "2026",
    date: "2026-01-15",
    tags: ["Documentary", "Platinum Jubilee", "History", "Madurai Province", "Heritage"],
    person: "Fr. Provincial SJ & Province Historians",
    speaker: "Fr. Provincial SJ",
    author: "JEMPARC Media Productions",
    source: "Province Archive Digital Repository",
    duration: "14:20",
    mimeType: "video/mp4",
    fileSize: "128 MB",
    visibility: "public",
    featured: true,
    uploadedBy: "Archivist Admin",
    uploadedAt: "2026-01-16T10:00:00Z",
    status: "active"
  },
  {
    id: "vid-002",
    title: "Solemn Jubilee Inauguration Mass & Address at St. Mary's Cathedral",
    description: "Live recording and highlights of the Platinum Jubilee inaugural holy mass and address by the Superior General's delegate.",
    mediaType: "video",
    fileName: "jubilee_inaugural_mass_2026.mp4",
    fileUrl: "https://commondatastorage.googleapis.com/gtv-videos-bucket/sample/ElephantsDream.mp4",
    thumbnailUrl: "https://images.unsplash.com/photo-1511578314322-379afb476865?auto=format&fit=crop&w=800&q=80",
    eventId: "evt-inauguration-2026",
    eventName: "Platinum Jubilee Inaugural Convocation",
    categoryId: "cat-spiritual",
    categoryName: "Spiritual & Liturgical",
    year: "2026",
    date: "2026-02-04",
    tags: ["Holy Mass", "Inauguration", "Liturgy", "2026"],
    person: "Archbishop & Provincial",
    speaker: "Fr. Provincial SJ",
    author: "Madurai Province Media Cell",
    source: "Archdiocese of Madurai & JEMPARC",
    duration: "09:45",
    mimeType: "video/mp4",
    fileSize: "86 MB",
    visibility: "public",
    featured: true,
    uploadedBy: "Archivist Admin",
    uploadedAt: "2026-02-05T14:30:00Z",
    status: "active"
  },
  {
    id: "vid-003",
    title: "Jesuit Heritage & Tamil Culture: Platinum Cantata & Dance Drama",
    description: "A vibrant multi-art production depicting St. John de Britto, Fr. Constanzo Beschi (Veeramamunivar), and modern Jesuit educators.",
    mediaType: "video",
    fileName: "tamil_heritage_cantata_2026.mp4",
    fileUrl: "https://commondatastorage.googleapis.com/gtv-videos-bucket/sample/ForBiggerBlazes.mp4",
    thumbnailUrl: "https://images.unsplash.com/photo-1465847899084-d164df4dedc6?auto=format&fit=crop&w=800&q=80",
    eventId: "evt-cultural-2026",
    eventName: "Jesuit Heritage & Cultural Festival 2026",
    categoryId: "cat-cultural",
    categoryName: "Cultural & Arts",
    year: "2026",
    date: "2026-03-12",
    tags: ["Cultural", "Veeramamunivar", "Music", "Drama"],
    person: "St. Joseph's Choral Ensemble",
    speaker: "Rev. Dr. Francis SJ",
    author: "Cultural Committee",
    source: "Trichy Performing Arts Center",
    duration: "18:05",
    mimeType: "video/mp4",
    fileSize: "164 MB",
    visibility: "public",
    featured: false,
    uploadedBy: "Archivist Admin",
    uploadedAt: "2026-03-13T09:15:00Z",
    status: "active"
  },
  {
    id: "vid-004",
    title: "Golden Jubilee Retrospective (2001): A Province Renewed",
    description: "Digitized 2001 video record capturing the 50th year Jubilee assemblies and reflections by senior Jesuit fathers at Shembaganur.",
    mediaType: "video",
    fileName: "golden_jubilee_2001_shembaganur.mp4",
    fileUrl: "https://commondatastorage.googleapis.com/gtv-videos-bucket/sample/ForBiggerEscapes.mp4",
    thumbnailUrl: "https://images.unsplash.com/photo-1519741497674-611481863552?auto=format&fit=crop&w=800&q=80",
    eventId: "evt-golden-2001",
    eventName: "Golden Jubilee Celebrations (2001)",
    categoryId: "cat-jubilee",
    categoryName: "Jubilee Celebrations",
    year: "2001",
    date: "2001-08-15",
    tags: ["Golden Jubilee", "2001", "Retrospective", "Shembaganur"],
    person: "Fr. Guy Archambeaud SJ",
    speaker: "Fr. Guy Archambeaud SJ",
    author: "Shembaganur Video Archives",
    source: "JEMPARC Historic VHS Conversion",
    duration: "11:32",
    mimeType: "video/mp4",
    fileSize: "98 MB",
    visibility: "public",
    featured: false,
    uploadedBy: "Archivist Admin",
    uploadedAt: "2026-01-10T12:00:00Z",
    status: "active"
  },

  // =================== AUDIO ===================
  {
    id: "aud-001",
    title: "Platinum Jubilee Choral Anthem: 'Ignited by Love and Service'",
    description: "Official Platinum Jubilee orchestral theme hymn composed for the 75th Jubilee Year, recorded with choir and symphony.",
    mediaType: "audio",
    fileName: "platinum_jubilee_anthem_2026.mp3",
    fileUrl: "https://actions.google.com/sounds/v1/ambiences/rain_heavy.ogg",
    thumbnailUrl: "https://images.unsplash.com/photo-1511671782779-c97d3d27a1d4?auto=format&fit=crop&w=800&q=80",
    eventId: "evt-jubilee-2026",
    eventName: "Platinum Jubilee Grand Celebration (2026)",
    categoryId: "cat-cultural",
    categoryName: "Cultural & Arts",
    year: "2026",
    date: "2026-01-15",
    tags: ["Jubilee Anthem", "Choir", "Hymn", "Platinum Anthem"],
    person: "Madurai Province Symphony & Choir",
    speaker: "St. Mary's Choir",
    author: "Fr. Maria Susai SJ & Ensemble",
    source: "JEMPARC Studio Recording",
    duration: "05:12",
    mimeType: "audio/mp3",
    fileSize: "8.2 MB",
    visibility: "public",
    featured: true,
    uploadedBy: "Archivist Admin",
    uploadedAt: "2026-01-16T11:20:00Z",
    status: "active"
  },
  {
    id: "aud-002",
    title: "Oral History Interview: Fr. Joseph Antony Samy SJ on Province Preservation",
    description: "In-depth audio interview reflecting on the archival legacy, early palm-leaf manuscripts preservation, and the milestone of 75 years.",
    mediaType: "audio",
    fileName: "interview_fr_joseph_antony_samy_2026.mp3",
    fileUrl: "https://actions.google.com/sounds/v1/foley/footsteps_on_cement.ogg",
    thumbnailUrl: "https://images.unsplash.com/photo-1478737270239-2f02b77fc618?auto=format&fit=crop&w=800&q=80",
    eventId: "evt-academic-2026",
    eventName: "International Symposium on Archival Heritage & Mission",
    categoryId: "cat-interviews",
    categoryName: "Oral Histories & Audio Speeches",
    year: "2026",
    date: "2026-04-18",
    tags: ["Oral History", "Archivist Interview", "Shembaganur", "Memoirs"],
    person: "Fr. Joseph Antony Samy SJ",
    speaker: "Fr. Joseph Antony Samy SJ",
    author: "Oral History Project",
    source: "JEMPARC Sound Archives",
    duration: "24:18",
    mimeType: "audio/mp3",
    fileSize: "22.5 MB",
    visibility: "public",
    featured: true,
    uploadedBy: "Archivist Admin",
    uploadedAt: "2026-04-19T08:00:00Z",
    status: "active"
  },
  {
    id: "aud-003",
    title: "Historic Address by Fr. John Pujo SJ (Silver Jubilee 1976)",
    description: "Restored magnetic tape recording of Fr. John Pujo SJ delivering the Silver Jubilee address on the preservation of mission records in 1976.",
    mediaType: "audio",
    fileName: "pujo_sj_silver_jubilee_address_1976.mp3",
    fileUrl: "https://actions.google.com/sounds/v1/water/rain_heavy.ogg",
    thumbnailUrl: "https://images.unsplash.com/photo-1590602847861-f357a9332bbc?auto=format&fit=crop&w=800&q=80",
    eventId: "evt-silver-1976",
    eventName: "Silver Jubilee Memorial & Archival Assembly (1976)",
    categoryId: "cat-interviews",
    categoryName: "Oral Histories & Audio Speeches",
    year: "1976",
    date: "1976-11-20",
    tags: ["Fr. John Pujo", "Silver Jubilee", "1976", "Vintage Audio"],
    person: "Fr. John Pujo SJ",
    speaker: "Fr. John Pujo SJ",
    author: "Historic Tape Collection",
    source: "Shembaganur Magnetic Audio Reel #12",
    duration: "16:40",
    mimeType: "audio/mp3",
    fileSize: "15.3 MB",
    visibility: "public",
    featured: false,
    uploadedBy: "Archivist Admin",
    uploadedAt: "2026-01-08T15:40:00Z",
    status: "active"
  },
  {
    id: "aud-004",
    title: "Homily: The Spirit of St. Ignatius in Tamil Nadu (1988)",
    description: "Archival recording of a commemorative sermon delivered on the feast of St. Ignatius at Sacred Heart College, Shembaganur.",
    mediaType: "audio",
    fileName: "ignatius_homily_shembaganur_1988.mp3",
    fileUrl: "https://actions.google.com/sounds/v1/ambiences/rain_heavy.ogg",
    thumbnailUrl: "https://images.unsplash.com/photo-1516280440614-37939bbacd81?auto=format&fit=crop&w=800&q=80",
    eventId: "evt-foundation-1952",
    eventName: "Promulgation & Foundation of the Madurai Province (1952)",
    categoryId: "cat-spiritual",
    categoryName: "Spiritual & Liturgical",
    year: "1988",
    date: "1988-07-31",
    tags: ["Homily", "St. Ignatius", "Spiritual", "Shembaganur"],
    person: "Fr. V. M. Gnanapragasam SJ",
    speaker: "Fr. V. M. Gnanapragasam SJ",
    author: "SHC Chapel Archive",
    source: "JEMPARC Sound Repository",
    duration: "12:05",
    mimeType: "audio/mp3",
    fileSize: "11.1 MB",
    visibility: "public",
    featured: false,
    uploadedBy: "Archivist Admin",
    uploadedAt: "2026-01-09T14:10:00Z",
    status: "active"
  },

  // =================== IMAGES ===================
  {
    id: "img-001",
    title: "Solemn Concelebration of the Platinum Jubilee Eucharistic Assembly",
    description: "Ecclesiastical leaders, provincials, and Jesuit fathers gathering at the high altar during the Platinum Jubilee Inauguration (2026).",
    mediaType: "image",
    fileName: "platinum_jubilee_concelebration_2026.jpg",
    fileUrl: "https://images.unsplash.com/photo-1548625361-195982885942?auto=format&fit=crop&w=1600&q=85",
    thumbnailUrl: "https://images.unsplash.com/photo-1548625361-195982885942?auto=format&fit=crop&w=600&q=80",
    eventId: "evt-jubilee-2026",
    eventName: "Platinum Jubilee Grand Celebration (2026)",
    categoryId: "cat-jubilee",
    categoryName: "Jubilee Celebrations",
    year: "2026",
    date: "2026-01-15",
    tags: ["Platinum Jubilee", "Concelebration", "St. Mary's", "Altar", "2026"],
    person: "Madurai Province Fathers & Bishops",
    speaker: "",
    author: "Province Official Photographer",
    source: "JEMPARC Digital Photo Archives",
    duration: "",
    mimeType: "image/jpeg",
    fileSize: "4.8 MB",
    visibility: "public",
    featured: true,
    uploadedBy: "Archivist Admin",
    uploadedAt: "2026-01-16T12:00:00Z",
    status: "active"
  },
  {
    id: "img-002",
    title: "Historic Inaugural Assembly at Loyola Hall, Shembaganur (1952)",
    description: "Rare vintage black-and-white photograph of the Jesuit fathers assembled for the formal promulgation of the Madurai Province in 1952.",
    mediaType: "image",
    fileName: "vintage_shembaganur_assembly_1952.jpg",
    fileUrl: "https://images.unsplash.com/photo-1461360370896-922624d12aa1?auto=format&fit=crop&w=1600&q=85",
    thumbnailUrl: "https://images.unsplash.com/photo-1461360370896-922624d12aa1?auto=format&fit=crop&w=600&q=80",
    eventId: "evt-foundation-1952",
    eventName: "Promulgation & Foundation of the Madurai Province (1952)",
    categoryId: "cat-history",
    categoryName: "Historical Documents & Manuscripts",
    year: "1952",
    date: "1952-03-12",
    tags: ["Vintage 1952", "Black and White", "Shembaganur", "Foundation"],
    person: "Founding Fathers & Fr. Augustine Sauliere SJ",
    speaker: "",
    author: "Province Historical Records",
    source: "Shembaganur Glass Plate Negatives #04",
    duration: "",
    mimeType: "image/jpeg",
    fileSize: "3.2 MB",
    visibility: "public",
    featured: true,
    uploadedBy: "Archivist Admin",
    uploadedAt: "2026-01-05T09:00:00Z",
    status: "active"
  },
  {
    id: "img-003",
    title: "Sacred Heart College Shembaganur - The Heritage Facade and Cloud Mist",
    description: "Scenic view of the historic Sacred Heart College building in Shembaganur, housing JEMPARC and generations of Jesuit scholarship.",
    mediaType: "image",
    fileName: "sacred_heart_college_shembaganur_facade.jpg",
    fileUrl: "https://images.unsplash.com/photo-1541339907198-e08756dedf3f?auto=format&fit=crop&w=1600&q=85",
    thumbnailUrl: "https://images.unsplash.com/photo-1541339907198-e08756dedf3f?auto=format&fit=crop&w=600&q=80",
    eventId: "evt-jubilee-2026",
    eventName: "Platinum Jubilee Grand Celebration (2026)",
    categoryId: "cat-mission",
    categoryName: "Mission & Institutions",
    year: "2026",
    date: "2026-02-10",
    tags: ["Shembaganur", "Architecture", "Sacred Heart College", "Heritage"],
    person: "",
    speaker: "",
    author: "JEMPARC Photography Team",
    source: "Institutional Heritage Library",
    duration: "",
    mimeType: "image/jpeg",
    fileSize: "5.1 MB",
    visibility: "public",
    featured: true,
    uploadedBy: "Archivist Admin",
    uploadedAt: "2026-02-11T16:20:00Z",
    status: "active"
  },
  {
    id: "img-004",
    title: "Fr. Augustine Sauliere SJ Digitized Glass Plate Archive (1960)",
    description: "Archivist Fr. Augustine Sauliere SJ inspecting missionary palm leaves and French mission folios in the archive chamber.",
    mediaType: "image",
    fileName: "fr_augustine_sauliere_archive_1960.jpg",
    fileUrl: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?auto=format&fit=crop&w=1600&q=85",
    thumbnailUrl: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?auto=format&fit=crop&w=600&q=80",
    eventId: "evt-foundation-1952",
    eventName: "Promulgation & Foundation of the Madurai Province (1952)",
    categoryId: "cat-people",
    categoryName: "Provincials, Archivists & Personalities",
    year: "1960",
    date: "1960-06-18",
    tags: ["Fr. Sauliere", "Archivist", "Historic Portrait", "1960s"],
    person: "Fr. Augustine Sauliere SJ",
    speaker: "",
    author: "Archival Documentation Team",
    source: "JEMPARC Archivist Memoir Series",
    duration: "",
    mimeType: "image/jpeg",
    fileSize: "2.9 MB",
    visibility: "public",
    featured: false,
    uploadedBy: "Archivist Admin",
    uploadedAt: "2026-01-07T11:45:00Z",
    status: "active"
  },
  {
    id: "img-005",
    title: "Alumni Gathering and Jubilee Banquet (St. Joseph's College, 2026)",
    description: "Distinguished alumni across four generations interacting during the Platinum Jubilee commemorative dinner and book release.",
    mediaType: "image",
    fileName: "alumni_jubilee_banquet_2026.jpg",
    fileUrl: "https://images.unsplash.com/photo-1523580494863-6f3031224c94?auto=format&fit=crop&w=1600&q=85",
    thumbnailUrl: "https://images.unsplash.com/photo-1523580494863-6f3031224c94?auto=format&fit=crop&w=600&q=80",
    eventId: "evt-alumni-2026",
    eventName: "All-India Jesuit Alumni Platinum Jubilee Assembly",
    categoryId: "cat-mission",
    categoryName: "Mission & Institutions",
    year: "2026",
    date: "2026-05-22",
    tags: ["Alumni", "St. Joseph's", "Jubilee Assembly", "2026"],
    person: "Alumni Association",
    speaker: "",
    author: "Alumni Affairs Directorate",
    source: "JEMPARC Photo Repository",
    duration: "",
    mimeType: "image/jpeg",
    fileSize: "3.7 MB",
    visibility: "public",
    featured: false,
    uploadedBy: "Archivist Admin",
    uploadedAt: "2026-05-23T10:00:00Z",
    status: "active"
  },
  {
    id: "img-006",
    title: "18th Century Palm-Leaf Manuscript (Olaichuvadi) Preservation Display",
    description: "High-resolution macro photograph of the ancient Tamil Christian palm leaves treated and preserved under conservation glass.",
    mediaType: "image",
    fileName: "olaichuvadi_palm_leaf_manuscript.jpg",
    fileUrl: "https://images.unsplash.com/photo-1455390582262-044cdead277a?auto=format&fit=crop&w=1600&q=85",
    thumbnailUrl: "https://images.unsplash.com/photo-1455390582262-044cdead277a?auto=format&fit=crop&w=600&q=80",
    eventId: "evt-academic-2026",
    eventName: "International Symposium on Archival Heritage & Mission",
    categoryId: "cat-history",
    categoryName: "Historical Documents & Manuscripts",
    year: "1970",
    date: "1970-04-12",
    tags: ["Olaichuvadi", "Palm Leaf", "Tamil Manuscript", "Conservation"],
    person: "JEMPARC Conservation Lab",
    speaker: "",
    author: "Preservation Division",
    source: "JEMPARC Rare Manuscripts Vault",
    duration: "",
    mimeType: "image/jpeg",
    fileSize: "6.4 MB",
    visibility: "public",
    featured: true,
    uploadedBy: "Archivist Admin",
    uploadedAt: "2026-01-04T14:15:00Z",
    status: "active"
  },

  // =================== DOCUMENTS ===================
  {
    id: "doc-001",
    title: "MDU Platinum Jubilee Commemorative Souvenir: 75 Years of Grace (1951-2026)",
    description: "Official 140-page Platinum Jubilee souvenir volume with comprehensive archival timelines, essays on Jesuit institutions, archival photographs, and messages from world Jesuit leadership.",
    mediaType: "document",
    fileName: "mdu_platinum_jubilee_souvenir_1951_2026.pdf",
    fileUrl: "https://www.w3.org/WAI/ER/tests/xhtml/testfiles/resources/pdf/dummy.pdf",
    thumbnailUrl: "https://images.unsplash.com/photo-1544716278-ca5e3f4abd8c?auto=format&fit=crop&w=600&q=80",
    eventId: "evt-jubilee-2026",
    eventName: "Platinum Jubilee Grand Celebration (2026)",
    categoryId: "cat-publications",
    categoryName: "Souvers & Province Bulletins",
    year: "2026",
    date: "2026-01-15",
    tags: ["Souvenir", "Platinum Jubilee", "Commemorative", "Publication", "1951-2026"],
    person: "Platinum Jubilee Editorial Board",
    speaker: "",
    author: "Rev. Fr. Provincial SJ & Editorial Committee",
    source: "JEMPARC Official Publications",
    duration: "",
    mimeType: "application/pdf",
    fileSize: "18.4 MB",
    pageCount: 140,
    visibility: "public",
    featured: true,
    uploadedBy: "Archivist Admin",
    uploadedAt: "2026-01-16T15:00:00Z",
    status: "active"
  },
  {
    id: "doc-002",
    title: "Canonical Decree of Roman Congregation: Foundation of Madurai Province (1952)",
    description: "Official Latin decree promulgated by the Society of Jesus in Rome establishing the Jesuit Province of Madurai as an independent administrative unit.",
    mediaType: "document",
    fileName: "canonical_decree_madurai_province_1952.pdf",
    fileUrl: "https://www.w3.org/WAI/ER/tests/xhtml/testfiles/resources/pdf/dummy.pdf",
    thumbnailUrl: "https://images.unsplash.com/photo-1455390582262-044cdead277a?auto=format&fit=crop&w=600&q=80",
    eventId: "evt-foundation-1952",
    eventName: "Promulgation & Foundation of the Madurai Province (1952)",
    categoryId: "cat-history",
    categoryName: "Historical Documents & Manuscripts",
    year: "1952",
    date: "1952-03-12",
    tags: ["Latin Decree", "Rome", "Foundation", "Canonical", "1952"],
    person: "Fr. John Baptist Janssens SJ (Superior General)",
    speaker: "",
    author: "General Curia of the Society of Jesus, Rome",
    source: "JEMPARC Roman Photostats Collection #01",
    duration: "",
    mimeType: "application/pdf",
    fileSize: "4.2 MB",
    pageCount: 8,
    visibility: "public",
    featured: true,
    uploadedBy: "Archivist Admin",
    uploadedAt: "2026-01-02T10:30:00Z",
    status: "active"
  },
  {
    id: "doc-003",
    title: "Historical Monograph: The Madurai Mission & Tamil Lexicography",
    description: "Scholarly research work analyzing the contributions of Fr. Constanzo Beschi (Veeramamunivar) and subsequent 19th and 20th-century Jesuit linguists to modern Tamil prose.",
    mediaType: "document",
    fileName: "madurai_mission_tamil_lexicography_study.pdf",
    fileUrl: "https://www.w3.org/WAI/ER/tests/xhtml/testfiles/resources/pdf/dummy.pdf",
    thumbnailUrl: "https://images.unsplash.com/photo-1497633762265-9d179a990aa6?auto=format&fit=crop&w=600&q=80",
    eventId: "evt-academic-2026",
    eventName: "International Symposium on Archival Heritage & Mission",
    categoryId: "cat-academic",
    categoryName: "Academic & Research Publications",
    year: "1985",
    date: "1985-09-20",
    tags: ["Monograph", "Veeramamunivar", "Tamil Studies", "Lexicography"],
    person: "Fr. V. M. Gnanapragasam SJ",
    speaker: "",
    author: "Fr. V. M. Gnanapragasam SJ",
    source: "JEMPARC Research Series No. 4",
    duration: "",
    mimeType: "application/pdf",
    fileSize: "8.7 MB",
    pageCount: 64,
    visibility: "public",
    featured: false,
    uploadedBy: "Archivist Admin",
    uploadedAt: "2026-01-08T16:00:00Z",
    status: "active"
  },
  {
    id: "doc-004",
    title: "Golden Jubilee Souvenir Volume (1951 - 2001)",
    description: "Complete historical retrospective published for the 50th year celebrations, documenting province expansion across Tamil Nadu and beyond.",
    mediaType: "document",
    fileName: "golden_jubilee_souvenir_2001.pdf",
    fileUrl: "https://www.w3.org/WAI/ER/tests/xhtml/testfiles/resources/pdf/dummy.pdf",
    thumbnailUrl: "https://images.unsplash.com/photo-1512820790803-83ca734da794?auto=format&fit=crop&w=600&q=80",
    eventId: "evt-golden-2001",
    eventName: "Golden Jubilee Celebrations (2001)",
    categoryId: "cat-publications",
    categoryName: "Souvenirs & Province Bulletins",
    year: "2001",
    date: "2001-08-15",
    tags: ["Golden Jubilee", "2001", "Souvenir", "Fifty Years"],
    person: "Fr. Guy Archambeaud SJ",
    speaker: "",
    author: "Madurai Province Information Desk",
    source: "JEMPARC Archives Reference Library",
    duration: "",
    mimeType: "application/pdf",
    fileSize: "14.6 MB",
    pageCount: 96,
    visibility: "public",
    featured: false,
    uploadedBy: "Archivist Admin",
    uploadedAt: "2026-01-09T11:00:00Z",
    status: "active"
  },
  {
    id: "doc-005",
    title: "Parish & Mission Register: Shembaganur Diaries (1895 - 1980 Summary)",
    description: "Archivist guide and summary catalog of the personal diaries, climate observations, and mission journals kept at Sacred Heart College Shembaganur.",
    mediaType: "document",
    fileName: "shembaganur_mission_diaries_register.docx",
    fileUrl: "https://calibre-ebook.com/downloads/demos/demo.docx",
    thumbnailUrl: "https://images.unsplash.com/photo-1455390582262-044cdead277a?auto=format&fit=crop&w=600&q=80",
    eventId: "evt-foundation-1952",
    eventName: "Promulgation & Foundation of the Madurai Province (1952)",
    categoryId: "cat-history",
    categoryName: "Historical Documents & Manuscripts",
    year: "1980",
    date: "1980-05-14",
    tags: ["Diaries", "Shembaganur", "Register", "Kodaikanal", "MS Word"],
    person: "Fr. Puthota Rayanna SJ",
    speaker: "",
    author: "JEMPARC Cataloguing Division",
    source: "Manuscripts & Registry Shelf #4",
    duration: "",
    mimeType: "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
    fileSize: "3.1 MB",
    pageCount: 32,
    visibility: "public",
    featured: false,
    uploadedBy: "Archivist Admin",
    uploadedAt: "2026-01-06T13:40:00Z",
    status: "active"
  }
];
